// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"RemixViewer_iframeWrapper__PKHuj","isDesktop":"RemixViewer_isDesktop__hRzJr","iframeInner":"RemixViewer_iframeInner__kD1G0","isMobile":"RemixViewer_isMobile__qnAnD"};